import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const companyAPI = {
  getInfo: () => api.get('/company-info'),
  updateInfo: (data) => api.put('/admin/company-info', data),
};

export const servicesAPI = {
  getAll: () => api.get('/services'),
  create: (data) => api.post('/admin/services', data),
  update: (id, data) => api.put(`/admin/services/${id}`, data),
  remove: (id) => api.delete(`/admin/services/${id}`),
};

export const testimonialsAPI = {
  getAll: () => api.get('/testimonials'),
  create: (data) => api.post('/admin/testimonials', data),
};

export const fleetAPI = {
  getAll: () => api.get('/fleet'),
  create: (data) => api.post('/admin/fleet', data),
  update: (id, data) => api.put(`/admin/fleet/${id}`, data),
  remove: (id) => api.delete(`/admin/fleet/${id}`),
};

export const logoAPI = {
  upload: (file) => {
    const form = new FormData();
    form.append('file', file);
    return api.post('/admin/upload-logo', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const imageAPI = {
  upload: (file) => {
    const form = new FormData();
    form.append('file', file);
    return api.post('/admin/upload-image', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const citiesAPI = {
  getAll: () => api.get('/cities'),
  getBySlug: (slug) => api.get(`/cities/${slug}`),
  adminGetAll: () => api.get('/admin/cities'),
  create: (data) => api.post('/admin/cities', data),
  update: (id, data) => api.put(`/admin/cities/${id}`, data),
  remove: (id) => api.delete(`/admin/cities/${id}`),
};

export const quoteAPI = {
  create: (data) => api.post('/quote-request', data),
  getAll: () => api.get('/admin/quote-requests'),
};

export const contactAPI = {
  create: (data) => api.post('/contact-message', data),
  getAll: () => api.get('/admin/contact-messages'),
};

export default api;